import { createFileRoute } from '@tanstack/react-router';
import { NotificationsSettings } from '../../../features/B9/notifications-settings';

// Settings → "התראות מערכת" — lane B9. Page head + tabs come from the settings layout (_app/settings.tsx, lane B1).
export const Route = createFileRoute('/_app/settings/notifications')({
  component: NotificationsSettings,
});
